import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// CONSTANTS
import { ROUTE_START } from '@/constants/routes';
import { LOCATIONS_PARTNER_TV_PAGE } from '@/constants/locations';

// UTILITY
import { analyticsStartFormLink } from '@/utility/analytics';

// COMPONENTS
import RouterLink from '@/components/Link';

const LeftSection = () => {
  const [t] = useTranslation();
  const { headerHeight, partner } = useSelector(({ app, partner: partnerStore }) => ({
    headerHeight: app.headerHeight,
    partner: partnerStore.data,
  }));
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const partnerSettings = partner.settings || {};
  const textOverwrites = partner.text_overwrites || {};

  let use_fmb = true;

  if (partner.partner_slug) {
    use_fmb = !!partnerSettings.use_fmb;
  }

  const handleStartClick = () => {
    analyticsStartFormLink({
      location: 'Center',
      type: 'Button',
    });
  };

  const scrollWithOffset = el => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = headerHeight ? -headerHeight : 0;

    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  };

  return (
    <div className="welcome__left">
      <Typography
        className="welcome__title m-b-20 break-spaces"
        variant={downXs ? 'h3' : 'h1'}
        component="h1"
      >
        <Trans>{textOverwrites?.tv_left_title || t('partnerTV.welcome.title')}</Trans>
      </Typography>
      <Typography className={clsx('welcome__subtitle m-b-35 break-spaces', downXs ? 'p5' : 'p2')}>
        <Trans>{textOverwrites?.tv_left_subtitle || t('partnerTV.welcome.subtitle')}</Trans>
      </Typography>
      {use_fmb && (
        <Button
          component={RouterLink}
          onClick={handleStartClick}
          to={ROUTE_START}
          color="primary"
          location={LOCATIONS_PARTNER_TV_PAGE}
          size={clsx(downXs ? 'medium' : 'large')}
        >
          {textOverwrites?.tv_left_button_text || t('buttons.getRecommendations')}
        </Button>
      )}
      <Typography className="p2 text-bold m-t-40">
        <Trans
          components={{
            a: (
              <Link
                className="p2 text-bold"
                target="_blank"
                underline="always"
                color="inherit"
                component={RouterLink}
              />
            ),
            hashLink: (
              <Link
                className="p2 text-bold"
                underline="always"
                color="inherit"
                component={HashLink}
                smooth
                scroll={el => scrollWithOffset(el)}
              />
            ),
          }}
        >
          {t('partnerTV.welcome.dontKnowWhereStart')}
        </Trans>
      </Typography>
    </div>
  );
};

export default React.memo(LeftSection);
